import { Head, router, useForm, usePage } from "@inertiajs/react"

import { JobForm, type JobFormData } from "@/components/jobs/job-form"
import AppLayout from "@/layouts/app-layout"
import { jobsPath } from "@/routes"

export default function JobsNew() {
  const page = usePage()
  const search = page.url.includes("?") ? page.url.split("?")[1] : ""
  const params = new URLSearchParams(search)
  const from = params.get("from")

  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { data, setData, post, processing, errors, reset } =
    useForm<JobFormData>({
      title: "",
      company_name: "",
      category: "tech",
      location_type: "onsite",
      apply_url: "",
      apply_instructions: "",
      description: "",
      status: "active",
    })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post(jobsPath(), {
      forceFormData: true,
      onSuccess: () => reset(),
    })
  }

  const handleCancel = () => {
    if (from) {
      router.visit(from)
    } else {
      router.visit(jobsPath())
    }
  }

  return (
    <AppLayout>
      <Head title="Publicar curro" />
      <div className="mx-auto max-w-6xl p-4 md:p-6">
        <JobForm
          title="Publicar curro"
          data={data}
          errors={errors as Record<string, string>}
          processing={processing}
          onChange={(partial) => {
            Object.entries(partial).forEach(([key, value]) => {
              setData(key as keyof JobFormData, value)
            })
          }}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          submitLabel="Publicar curro"
        />
      </div>
    </AppLayout>
  )
}
